<template>
  <div class="flex flex-row justify-between max-w-full overflow-hidden">
    <div>
      <div class="inline-flex py-3">
        <div v-if="runtimeConfig.public.partnerCode?.toLowerCase() !== 'iocl'" class="flex shrink-0 grow-0 py-3">
          <NuxtLink to="/" @click="onLogoClick">
            <img
              :src= runtimeConfig.public.partnerLogo
              :alt="`${partnerName} logo`"
              title="Go to homepage"
              class="h-11 w-11"
            />
          </NuxtLink>
        </div>
        <div v-if="!islocationCompDisabled" class="flex shrink px-2" >
          <V3LocationComponent />
        </div>
      </div>
    </div>
    <div class="inline-flex items-end justify-end">
      <div class="hidden sm:block">
        <div class="pr-2 cursor-pointer">
          <div class="flex justify-between">
            <div
              v-for="item in navIcons.topNavIcons"
              :key="item.name"
              @click="handleTopNavigationClick(item.name, item.label)"
              class="relative w-[72px] flex flex-col items-center justify-between px-1 cursor-pointer"
              :class="{ '': isActiveTopNavItem(item) }"
            >
              <div class="flex items-center justify-center">
                <img
                  :src="isActiveTopNavItem(item) ? item.activeIcon : item.icon"
                  :alt="`${item.label} navigation icon`"
                  :title="item.label"
                  class="w-6 h-6"
                />
              </div>
              <div
                class="w-[72px] text-ellipsis overflow-hidden whitespace-nowrap text-center text-xs leading-5 pb-2 text-navyPrime"
                :class="{ 'text-primary-600': isActiveTopNavItem(item) }"
              >
                {{ item.label }}
              </div>
              <!-- cart icon's item count badge -->
              <div
                class="absolute bottom-0 w-full h-1.5 bg-primary-500 rounded-t-lg"
                v-if="isActiveTopNavItem(item)"
              ></div>
              <span
                v-if="(item.name === '/cart' || item.name === '/collections/gift-cards/cart') && item.badge > 0"
                  class="absolute -top-1 right-4 bg-primary-600 text-white text-xs leading-2 rounded-full h-4 w-4 flex items-center justify-center"
              >
                {{ item.badge }}
              </span>
            </div>
            <div class="px-1 h-8 border-r-2 border-gray-200"></div>
          </div>
        </div>
      </div>
      <div v-if="reward.enabled" class="flex flex-col items-center w-14 mb-2.5 gap-0.5">
        <UIcon name="i-fluent-wallet-credit-card-16-regular" class="text-primeval-700 h-7 w-7 mx-auto"/>
        <span class="text-xs font-bold text-navyPrime">{{ reward.rewardPoints }}</span>
      </div>
      <div class="flex flex-col items-center px-2 cursor-pointer mb-2.5" @click="handleNavigate()" v-if="partnerCode.toLowerCase() === 'cub'">
          <UIcon
            name="i-heroicons-arrow-uturn-left"
            class="h-5 w-5 mb-1 text-navyPrime dark:text-white"
          />
          <p class="text-xs leading-5 text-navyPrime dark:text-white text-center">
            {{isMobile? 'Rewards': 'CUB Rewards'}}
          </p>
      </div>
      <div class="pl-2">
        <!-- mobile view -->
        <div
          class="relative inline-flex items-center justify-center flex-shrink-0 sm:hidden mb-2.5"
          @click="showQuickMenu"
        >
          <div class="flex flex-col items-center pr-4 grow-0 shrink-0">
            <img
              loading="lazy"
              class="w-6 h-6"
              src="@/public/v1/icons/user.png"
              alt="Profile icon"
              title="Open profile menu"
            />
            <span class="text-xs dark:text-black mt-0.5">Profile</span>
          </div>
          <span
            v-if="authToken ? true : false"
            class="absolute rounded-full ring-1 ring-white dark:ring-gray-900 flex items-center justify-center text-white dark:text-gray-900 font-medium whitespace-nowrap h-2 min-w-[0.5rem] text-[7px] p-0.5 top-0 right-5 bg-green-500 dark:bg-green-400"
          ></span>
        </div>
        <!-- web view -->
        <div
          class="relative inline-flex items-center justify-center flex-shrink-0 hidden sm:block pb-2"
          @click="showQuickMenu"
        >
          <div class="flex flex-col items-center grow-0 shrink-0">
            <img
              loading="lazy"
              class="w-6 h-6"
              src="@/public/v1/icons/navy-profile-nav-icon.png"
              alt="Profile icon"
              title="Open profile menu"
            />
            <p class="text-xs leading-5 text-navyPrime dark:text-black">
              Profile
            </p>
          </div>
          <span
            v-if="authToken ? true : false"
            class="absolute rounded-full ring-1 ring-white dark:ring-gray-900 flex items-center justify-center text-white dark:text-gray-900 font-medium whitespace-nowrap h-2 min-w-[0.5rem] text-[7px] p-0.5 top-0 right-1 bg-green-500 dark:bg-green-400"
          ></span>
        </div>
        <!-- <UChip class="hidden sm:block" size="sm" color="green" :show="authToken ? true : false" inset
          @click="showQuickMenu">
          <div class="flex flex-col items-center px-4 grow-0 shrink-0 ">
            <V3ImageComponent src="icons/navy-profile-nav-icon.png" class="w-6 h-6" />
            <p class="text-xs leading-5 pb-2 dark:text-black">Profile</p>
          </div>
        </UChip> -->
        <!-- <UChip class="sm:hidden mb-6" size="sm" color="green" :show="authToken ? true : false" inset
          @click="showQuickMenu">
          <div class="flex flex-col items-center px-4 grow-0 shrink-0 ">
            <V3ImageComponent src="icons/user.png" class="w-6 h-6" /> -->
        <!-- <p class="text-xs leading-5 pb-2 dark:text-black">Profile</p> -->
        <!-- </div>
        </UChip> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { V3PopupComponent } from "#components";
import { V3ModalComponent } from "#components";
import { popupBackHandler } from "@/composables/popupBackHandler";
import { GoogleAnalytics } from "~/google_analytics/events";
import { EventParameter } from "~/google_analytics/events.enum";

const navIcons = useNavIcons();
const { gtag } = useGtag();
const runtimeConfig = useRuntimeConfig()
const partnerName = usePartnerDisplayName(runtimeConfig.public.partnerCode);
const auth = useAuth();
const reward = useReward();
const cubRewardsHomepage = runtimeConfig.public.cubRewardsHomepage;
const partnerCode = runtimeConfig.public.partnerCode;
const isAuthenticated = auth && auth.access_token;
const userData = isAuthenticated
  ? {
      user_name: auth.user.first_name,
      user_phone: auth.user.phone,
      user_email: auth.user.email,
    }
  : {
      user_name: null,
      user_phone: null,
      user_email: null,
    };

const props = defineProps({
  title: { type: String, default: "" },
  cart: { type: Boolean, default: true },
  homeNavigation: { type: Boolean, default: false },
  nativeAppNavigation: { type: Boolean, default: false },
});

const cartCount = computed(() => useCart().itemCount);

const giftCartCount = computed(() => useGiftCart().itemCount);

const { getTrackingContext } = useTracking();
const trackingContext = getTrackingContext();
const route = useRoute();
const isHomepage = computed(() => route.name === "index");
const router = useRouter();
const blacklist = ["finance-app-dashboard"];
const islocationCompDisabled = blacklist.includes(route.name.toLowerCase());
const handleNavigateToBack = () => {
  props.nativeAppNavigation
    ? handleNavigateToApp()
    : props.homeNavigation
    ? navigateTo({ path: "/" })
    : router.back();
};
const handleNavigateToApp = () => {
  try {
    if (navigator.userAgent.toLowerCase().indexOf("android") > -1) {
      window.pwa.postMessage();
    } else if (navigator.userAgent.toLowerCase().indexOf("iphone") > -1) {
      window.webkit.messageHandlers.pwa.postMessage();
    } else {
      console.log("App navigation not supported by browser!");
    }
  } catch (error) {
    console.error(error.message);
  }
};
const handleNavigate = () => {
   if (partnerCode.toLowerCase() === 'cub') {
    console.log('Redirecting to: ', cubRewardsHomepage);
    window.location.href = cubRewardsHomepage;
  }
};

const { isMobile } = useDevice();
const slideover = useSlideover();
const modal = useModal();
const authToken = computed(() => auth.access_token);
const { isPopupOpen, openPopup, closePopup } = popupBackHandler();

const showQuickMenu = () => {
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: "profile" || "",
  });
  if (!auth.access_token) {
    const options = {
      component: "login",
      onSuccess: () => {
        useSSOAuth('/menu')
      },
    };
    if (isMobile) {
      slideover.open(V3PopupComponent, {
        ...options,
        onClose: () => {
          slideover.close();
          // closePopup();
        },
      });
      // openPopup();
    } else {
      modal.open(V3ModalComponent, {
        ...options,
        onClose: () => {
          modal.close();
          // closePopup();
        },
      });
      // openPopup();
    }
    return;
  }
  return navigateTo({ path: "/menu" });
};

const showHomepage = async () => {
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: "header_home_icon" || "",
  });
  await navigateTo({ path: "/" });
};

const onLogoClick = async () => {
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: "header_logo_icon" || "",
  });
};

const navCart = async () => {
  const giftCart = useGiftCart();
  if (giftCart.itemCount > 0) {
    await navigateTo({ path: "/collections/gift-cards/cart" });
  } else {
    await navigateTo({ path: "/cart" });
  }
};
const location = useLocation();
const isLocationAvailable = computed(() => location.isGPSEnabled);
const handleNavigateToCart = async () => {
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: "header_cart_icon" || "",
  });

  if (!isLocationAvailable.value && isAuthenticated && route.path !== '/loans') {
    if (isMobile) {
      slideover.open(V3PopupComponent, {
        component: "location",
        closable: false,
        onSuccess: () => navCart(),
        onClose: slideover.close,
      });
    } else {
      modal.open(V3ModalComponent, {
        component: "location",
        closable: false,
        onSuccess: () => navCart(),
        onClose: modal.close,
      });
    }
    return;
  } else {
    await navCart();
  }
};

onMounted(() => {
  navIcons.getTopNavIcons();
});

const isActiveTopNavItem = (item) => {
  return route.path === item.name;
};
const handleTopNavigationClick = async (routeName, itemLabel) => {
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: `navbar_${itemLabel}` || "",
  });
  let routes = [
    "/account/orders",
   // "/cart",
    "/menu",
    "/select-location",
    "/account/tickets",
    "/account/profile",
    "/support/raise_a_request",
  ];
  if (isAuthenticated == null && routes.includes(routeName)) {
    if (isMobile) {
      slideover.open(V3PopupComponent, {
        component: "login",
        closable: true,
        onSuccess: () => {
          useSSOAuth(routeName);
        },
        onClose: slideover.close,
      });
    } else {
      modal.open(V3ModalComponent, {
        component: "login",
        closable: true,
        onSuccess: () => {
          useSSOAuth(routeName);
        },
        onClose: modal.close,
      });
    }
    return;
  } else {
    await navigateTo({ path: routeName });
  }
};

// watch(isPopupOpen, (newVal) => {
//   if (!newVal) {
//     slideover.close();
//     modal.close();
//   }
// });
</script>
